const TRANSLATE = {
  title: 'Usuarios',
  'menu.import': 'Importar',
  'menu.importHistory': 'Historial de importación',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Historial de exportación',
  'menu.group': 'Registro de grupos',
  'menu.triggers': 'Automatizaciones',
  'menu.fields': 'Personalizar campos adicionales',
  'menu.templates': 'Plantillas de Documento',
  'menu.templateHistory': 'Historial de Documento',
  'menu.publicToken': 'Tokens públicos',
  name: 'Nombre',
  email: 'Email',
  group: 'Grupo',
  profile: 'Perfil',
  newApp: '¿Nueva app?',
  enabled: 'Activado',
  fields: {
    NAME: 'Nombre',
    EMAIL: 'Email',
    GROUP_NAME: 'Grupo',
    PROFILE_NAME: 'Perfil',
    LAST_LOGIN_AT: 'Último acceso'
  },
  pageGuide: {
    description:
      'En usuarios, darás acceso a todas las personas de tu equipo que usarán Btime! Aquí puedes organizar tu equipo a través de perfiles, definiendo lo que cada uno tiene acceso y lo que puede o no hacer',
    howToCreate: '¿Cómo crear un usuario?',
    howToEdit: '¿Cómo editar un usuario?',
    howToDelete: '¿Cómo eliminar un usuario?',
    howToFilter: '¿Cómo filtrar la lista de usuarios?',
    contactSupport: 'Contáctanos y resuelve tus dudas'
  }
}

export default TRANSLATE
